'use client';

import {
    Box,
    BoxContent,
    BoxHeader,
    Column,
    Columns,
    Image,
    Spacer,
    SpacerSize,
    Text,
    TextLevels,
    Title,
    TitleLevels,
    TitleMarkup,
    TypographyBold,
} from '@bytel/trilogy-react';

import { FaiProduct, RangesNewGeneration } from '@app-types/fai';
import { JOURNEYS } from '@app-types/product';

import { useHome } from '@landing/hooks';

import { CtaAddToCart } from '../cta-add-to-cart';
import { AnniversaryMsl } from './anniversary-msl';
import { BBoxDetail } from './b-box-detail';

interface BboxCardProps {
    selectedOffer?: FaiProduct | null;
    onClickDetails: (offerRange: RangesNewGeneration) => void;
}

export default function BboxCard({ selectedOffer, onClickDetails }: Readonly<BboxCardProps>) {
    const {
        setSelectedFaiOption,
        selectedFaiProduct,
        temporarilySelectedFaiProduct,
        setSelectedFaiProduct,
        otisConfigurator,
    } = useHome();
    const isFaiFirst = otisConfigurator.value === JOURNEYS.FAI;
    const offerTitle = selectedOffer?.title?.replace('Pure fibre', 'Pure fibre');
    const isAnniversaryMSL =
        selectedOffer?.commercial_series === 'serie_speciale' &&
        (selectedOffer?.range_ng === RangesNewGeneration.VERY_FIT ||
            selectedOffer?.range_ng === RangesNewGeneration.ULTYM);

    return (
        <Box shadowless flat>
            {selectedOffer?.hat && (
                <BoxHeader className='has-text-centered is-justified-center'>{selectedOffer.hat}</BoxHeader>
            )}
            <BoxContent>
                <Columns mobile gap={1}>
                    <Column>
                        <Title markup={TitleMarkup.H3} level={TitleLevels.FOUR}>
                            {offerTitle}
                        </Title>
                        {isAnniversaryMSL && (
                            <>
                                <AnniversaryMsl />
                                <Spacer size={SpacerSize.FOUR} />
                            </>
                        )}
                        <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} level={TextLevels.ONE}>
                            {selectedOffer?.subtitle}
                        </Text>
                    </Column>
                    <Column narrow>
                        {selectedOffer?.image_url ? <Image src={selectedOffer?.image_url} width={90} alt='' /> : null}
                    </Column>
                </Columns>
                <Spacer size={SpacerSize.FOUR} />
                <BBoxDetail selectedFaiProduct={selectedOffer} />
                {!isFaiFirst && (
                    <>
                        <Spacer size={SpacerSize.FIVE} />
                        <CtaAddToCart
                            selectedProduct={selectedFaiProduct}
                            temporarilySelectedProduct={temporarilySelectedFaiProduct}
                            handleAddToCart={() => {
                                if (
                                    selectedFaiProduct?.gencode_offre !== temporarilySelectedFaiProduct?.gencode_offre
                                ) {
                                    setSelectedFaiProduct(temporarilySelectedFaiProduct || null);
                                } else {
                                    setSelectedFaiProduct(null);
                                    setSelectedFaiOption('');
                                }
                            }}
                            ctaLabel={{
                                productAdded: 'Retirer cette box',
                                productNotAdded: 'Ajouter cette box',
                                tagAdded: 'Bbox ajoutée',
                            }}
                        />
                    </>
                )}
                <div className='has-text-centered'>
                    <button
                        data-testid='btn_see_details'
                        className='link button-clear'
                        onClick={() => onClickDetails(selectedOffer!.range_ng)}
                    >
                        Voir les détails de l&apos;offre
                    </button>
                </div>
            </BoxContent>
        </Box>
    );
}
